const FULLSIZE_CLASS_BODY = 'main-container--fullsize';

export class FullSizeService {
  private body: HTMLBodyElement = document.getElementsByTagName('body')[0];

  /*
   * @type property
   * @name @poseidon/pos-full-size/PosFullSizeService#fullSize
   *
   * @description property that controls the fullsize CSS class
   *
   * @return {boolean}
   */
  set fullSize(value: boolean) {
    if (value) {
      this.body.classList.add(FULLSIZE_CLASS_BODY);
    } else {
      this.body.classList.remove(FULLSIZE_CLASS_BODY);
    }
  }

  /*
   * @type property
   * @name @poseidon/pos-full-size/PosFullSizeService#fullSize
   *
   * @description property that controls the fullsize CSS class
   *
   * @return {boolean}
   */
  get fullSize(): boolean {
    return this.body.classList.contains(FULLSIZE_CLASS_BODY);
  }
}

export const fullSizeService = new FullSizeService();
